module.exports = __webpack_public_path__ + "static/fonts/squadaone-aorm.1aa71af.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/squadaone-aorm.ttf
// module id = FXv/
// module chunks = 1